import styled from 'styled-components';
import { LoadingMask, PropertyCard } from '@zillow/constellation';

export const BlockLoadingMask = styled(LoadingMask)`
  display: block;
`;

export const TallHeightLoadingMask = styled(BlockLoadingMask)`
  min-height: 70vh;
`;

export const FullHeightLoadingMask = styled(BlockLoadingMask)`
  height: 100%;
`;

export const FullWidthPropertyCard = styled(PropertyCard)`
  max-width: 100% !important;
`;
